import { Platform } from './platform';
import { inject, Injectable, signal } from '@angular/core';
import { Storage } from './storage';
import { DARK_MODE_KEY } from '../constants/storage-keys.constants';

@Injectable({
  providedIn: 'root',
})
export class Theme {
  private storage = inject(Storage);
  private platform = inject(Platform);

  private _darkMode = signal<boolean>(false);

  readonly darkMode = this._darkMode.asReadonly();

  constructor() {
    this.init();
  }

  init() {
    const stored = this.storage.get<boolean>('local', DARK_MODE_KEY);
    this.setDarkMode(stored ?? false);
  }

  setDarkMode(value: boolean) {
    if (this.platform.isServer) return;
    this._darkMode.set(value);
    document.documentElement.classList.toggle('dark', value);
    this.storage.set('local', DARK_MODE_KEY, value);
  }
}
